import { render, staticRenderFns } from "./contactRecruiter.vue?vue&type=template&id=50bd660e"
import script from "./contactRecruiter.vue?vue&type=script&lang=js"
export * from "./contactRecruiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports